export default "__VITE_ASSET__BWLW_Bkj__"